import { render, staticRenderFns } from "./CareerMajorStep.vue?vue&type=template&id=ea2d5a8c&scoped=true&"
import script from "./CareerMajorStep.vue?vue&type=script&lang=js&"
export * from "./CareerMajorStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2d5a8c",
  null
  
)

export default component.exports